var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventory48Dp5F6368Fill0Wght700Grad200Opsz48(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M620-147 451-316l61-62 108 108 229-229 61 61-290 291Zm242-425h-92v-198h-55v98H245v-98h-55v581h241v91H190q-38.43 0-64.71-26.01Q99-150.02 99-189v-581q0-38.97 25.31-65.49Q149.63-862 190-862h175q10-34 41.46-58t73.57-24Q521-944 552-920.5t44 58.5h174q40.38 0 66.19 26.51Q862-808.97 862-770v198ZM480.5-780q15.5 0 27.5-12.5t12-28q0-16.5-12-28T480-860q-16 0-28 11.5T440-820q0 15 12 27.5t28.5 12.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory48Dp5F6368Fill0Wght700Grad200Opsz48);
export default __webpack_public_path__ + "static/media/inventory_48dp_5F6368_FILL0_wght700_GRAD200_opsz48.95f396954a2c8af75dc24d32d502b6fa.svg";
export { ForwardRef as ReactComponent };